import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { zPipelineTypeFilter } from 'client/zod.gen';
import { zFiltersArray } from 'helpers/router';

export const userPipelinesSearchSchema = z.object({
  // Inbound deep links seed the filter via `type`; the filter hook itself
  // round-trips `pipeline_type`. Both need scalar→array coercion.
  pipeline_type: zFiltersArray(zPipelineTypeFilter),
  type: zFiltersArray(zPipelineTypeFilter),
});

export const Route = createFileRoute(
  '/_private/_route/users/$userId/pipelines/',
)({
  validateSearch: userPipelinesSearchSchema,
});
